import { TFunction } from "react-i18next";
import {
	ClientApi,
	PrintoutTemplateApi,
	PrintoutTemplateFontSizeType,
} from "../../../../../../../../../services/Api/Organization/types";
import { PrintoutExampleData } from "../components/PrintoutTemplateForm";

const fontOptions = [
	PrintoutTemplateFontSizeType.SMALL,
	PrintoutTemplateFontSizeType.DELIVERY,
	PrintoutTemplateFontSizeType.LARGE,
	PrintoutTemplateFontSizeType.LARGE_DOUBLE_WIDTH,
	PrintoutTemplateFontSizeType.DOUBLE_WIDTH,
];

export const getPrintoutTemplateFontOptions = (t: TFunction, omitted?: PrintoutTemplateFontSizeType[]) =>
	fontOptions
		.filter((option) => !omitted?.includes(option))
		.map((option) => ({
			label: t(`enums.printout.font.${option}`),
			value: option,
		}));

export const getPrintoutTemplateSettingsForSmallFont = (): Record<string, any> => {
	return {
		print_point_of_sale: true,
		print_point_of_sale_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_number_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_number_bold: true,
		print_number: true,
		print_direction_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_direction: true,
		print_employee_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_employee: true,
		print_client_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_client: true,
		print_delivery_employee_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_delivery_employee: true,
		print_address_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_address: true,
		print_item_comment_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_item_comment: true,
		print_comment_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_comment_bold: true,
		print_comment: true,
		print_course_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_course_bold: true,
		print_course: true,
		print_table_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_table: true,
		print_number_of_guests_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_number_of_guests: true,
		print_takeaway_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_takeaway: true,
		print_included_additions_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_included_additions: true,
		print_prices: true,
		print_origin_of_item_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_origin_of_item: true,
		print_payment_method_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_payment_method: true,
		print_total_price_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_total_price: true,
		print_pickup_at_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_pickup_at: true,
		items_text_size: PrintoutTemplateFontSizeType.SMALL,
		items_bold: true,
		additions_text_size: PrintoutTemplateFontSizeType.SMALL,
		additions: true,
		print_seat_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_seat_bold: true,
		print_seat: true,
		print_payment_status_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_payment_status_bold: true,
		print_payment_status: true,
		print_other_directions_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_other_directions: true,
		print_other_directions_bold: true,
		print_direction_if_different_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_direction_if_different: true,
		print_direction_if_differenct_bold: true,
	};
};

export const getPrintoutTemplateSettingsForLargeFont = (): Record<string, any> => {
	return {
		print_point_of_sale: true,
		print_point_of_sale_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_number_text_size: PrintoutTemplateFontSizeType.LARGE_DOUBLE_WIDTH,
		print_number_bold: true,
		print_number: true,
		print_direction_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_direction: true,
		print_employee_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_employee: true,
		print_client_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_client: true,
		print_delivery_employee_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_delivery_employee: true,
		print_address_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_address: true,
		print_item_comment_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_item_comment: true,
		print_comment_text_size: PrintoutTemplateFontSizeType.LARGE_DOUBLE_WIDTH,
		print_comment_bold: true,
		print_comment: true,
		print_course_text_size: PrintoutTemplateFontSizeType.LARGE_DOUBLE_WIDTH,
		print_course_bold: true,
		print_course: true,
		print_table_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_table: true,
		print_number_of_guests_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_number_of_guests: true,
		print_takeaway_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_takeaway: true,
		print_included_additions_text_size: PrintoutTemplateFontSizeType.LARGE_DOUBLE_WIDTH,
		print_included_additions: true,
		print_prices: true,
		print_origin_of_item_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_origin_of_item: true,
		print_payment_method_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_payment_method: true,
		print_total_price_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_total_price: true,
		print_pickup_at_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_pickup_at: true,
		items_text_size: PrintoutTemplateFontSizeType.LARGE_DOUBLE_WIDTH,
		items_bold: true,
		additions_text_size: PrintoutTemplateFontSizeType.LARGE_DOUBLE_WIDTH,
		additions: true,
		print_seat_text_size: PrintoutTemplateFontSizeType.LARGE_DOUBLE_WIDTH,
		print_seat_bold: true,
		print_seat: true,
		print_payment_status_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_payment_status_bold: true,
		print_payment_status: true,
		print_other_directions_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_other_directions: true,
		print_other_directions_bold: true,
		print_direction_if_different_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_direction_if_different: true,
		print_direction_if_differenct_bold: true,
	};
};

export const getPrintoutTemplateSettingsForDeliveryFont = (): Record<string, any> => {
	return {
		print_point_of_sale: false,
		print_number_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_number_bold: true,
		print_number: true,
		print_direction: false,
		print_employee: false,
		print_client_text_size: PrintoutTemplateFontSizeType.LARGE,
		print_client: true,
		print_client_bold: true,
		print_delivery_employee_text_size: PrintoutTemplateFontSizeType.SMALL,
		print_delivery_employee: true,
		print_delivery_employee_bold: true,
		print_address_text_size: PrintoutTemplateFontSizeType.LARGE,
		print_address: true,
		print_address_bold: true,
		print_item_comment: false,
		print_comment_text_size: PrintoutTemplateFontSizeType.LARGE,
		print_comment_bold: true,
		print_comment: true,
		print_course: false,
		print_table: false,
		print_number_of_guests: false,
		print_takeaway_text_size: PrintoutTemplateFontSizeType.LARGE,
		print_takeaway: true,
		print_takeaway_bold: true,
		print_included_additions: false,
		print_prices: true,
		print_origin_of_item: false,
		print_payment_method_text_size: PrintoutTemplateFontSizeType.LARGE,
		print_payment_method: true,
		print_payment_method_bold: true,
		print_total_price_text_size: PrintoutTemplateFontSizeType.LARGE,
		print_total_price: true,
		print_total_price_bold: true,
		print_pickup_at_text_size: PrintoutTemplateFontSizeType.LARGE,
		print_pickup_at: true,
		print_pickup_at_bold: true,
		items_text_size: PrintoutTemplateFontSizeType.SMALL,
		items_bold: true,
		additions_text_size: PrintoutTemplateFontSizeType.SMALL,
		additions: true,
		print_seat: false,
		print_payment_status_text_size: PrintoutTemplateFontSizeType.LARGE,
		print_payment_status_bold: true,
		print_payment_status: true,
		print_other_directions_text_size: PrintoutTemplateFontSizeType.LARGE,
		print_other_directions: true,
		print_other_directions_bold: true,
		print_direction_if_different_text_size: PrintoutTemplateFontSizeType.LARGE,
		print_direction_if_different: true,
		print_direction_if_differenct_bold: true,
	};
};

const getOptionsBasedOnFont = (font: PrintoutTemplateFontSizeType) => {
	switch (font) {
		case PrintoutTemplateFontSizeType.LARGE: {
			return getPrintoutTemplateSettingsForLargeFont();
		}
		case PrintoutTemplateFontSizeType.DELIVERY:
			return getPrintoutTemplateSettingsForDeliveryFont();

		case PrintoutTemplateFontSizeType.SMALL:
		default:
			return getPrintoutTemplateSettingsForSmallFont();
	}
};

export const getDefaultPrintoutTemplateFormValues = (printoutTemplate: PrintoutTemplateApi) => {
	if (!printoutTemplate.id) {
		return {
			...printoutTemplate,
			...getPrintoutTemplateSettingsForSmallFont(),
			additions: true,
			items: true,
		} as PrintoutTemplateApi;
	}

	const options = getOptionsBasedOnFont(printoutTemplate.items_text_size);
	return {
		...printoutTemplate,
		additions: true,
		items: true,
		additions_text_size: printoutTemplate.additions_text_size ?? options.additions_text_size,
		print_point_of_sale_text_size:
			printoutTemplate.print_point_of_sale_text_size ?? options?.print_point_of_sale_text_size,
		print_direction_text_size: printoutTemplate.print_direction_text_size ?? options?.print_direction_text_size,
		print_client_text_size: printoutTemplate.print_client_text_size ?? options?.print_client_text_size,
		print_address_text_size: printoutTemplate.print_address_text_size ?? options?.print_address_text_size,
		print_comment_text_size: printoutTemplate.print_comment_text_size ?? options?.print_comment_text_size,
		print_table_text_size: printoutTemplate.print_table_text_size ?? options?.print_table_text_size,
		print_number_of_guests_text_size:
			printoutTemplate.print_number_of_guests_text_size ?? options?.print_number_of_guests_text_size,
		print_takeaway_text_size: printoutTemplate.print_takeaway_text_size ?? options?.print_takeaway_text_size,
		print_number_text_size: printoutTemplate.print_number_text_size ?? options?.print_number_text_size,
		print_employee_text_size: printoutTemplate.print_employee_text_size ?? options?.print_employee_text_size,
		print_delivery_employee_text_size:
			printoutTemplate.print_delivery_employee_text_size ?? options?.print_delivery_employee_text_size,
		print_course_text_size: printoutTemplate.print_course_text_size ?? options?.print_course_text_size,
		print_seat_text_size: printoutTemplate.print_seat_text_size ?? options?.print_seat_text_size,
		print_item_comment_text_size:
			printoutTemplate.print_item_comment_text_size ?? options?.print_item_comment_text_size,
		print_included_additions_text_size:
			printoutTemplate.print_included_additions_text_size ?? options?.print_included_additions_text_size,
		print_origin_of_item_text_size:
			printoutTemplate.print_origin_of_item_text_size ?? options?.print_origin_of_item_text_size,
		print_payment_method_text_size:
			printoutTemplate.print_payment_method_text_size ?? options?.print_payment_method_text_size,
		print_total_price_text_size:
			printoutTemplate.print_total_price_text_size ?? options?.print_total_price_text_size,
		print_payment_status_text_size:
			printoutTemplate.print_payment_status_text_size ?? options?.print_payment_status_text_size,
		print_pickup_at_text_size: printoutTemplate.print_pickup_at_text_size ?? options?.print_pickup_at_text_size,
		items_text_size: printoutTemplate.items_text_size ?? options?.items_text_size,
		print_other_directions_text_size:
			printoutTemplate.print_other_directions_text_size ?? options?.print_other_directions_text_size,
		print_direction_if_different_text_size:
			printoutTemplate.print_direction_if_different_text_size ?? options?.print_direction_if_different_text_size,
	} as PrintoutTemplateApi;
};

export const getPrintoutDataTemplate = (t: TFunction): PrintoutExampleData => ({
	date: "2022-04-07 18:00",
	ordered_at: "2022-04-07 16:30",
	point_of_sale: "BAR #1",
	direction: "Pizza",
	table: `10 (${t("modules.printout_template.field.main_hall.title")})`,
	guest_amount: 2,
	order_no: "212123",
	employee_name: "Jan Kowalski",
	driver_name: "Robert Kubica",
	comment: t("modules.printout_template.field.comment_example.title"),
	price_sum: "99.00 PLN",
	items: [
		{
			course: 1,
			items: [
				{
					name: "Pizza Margherita",
					quantity: 1,
					seat_name: `${t("modules.printout_template.field.guest.title")} nr 1`,
					item_course: "3",
					price: "26.00 PLN",
					included_additions: [
						{
							name: t("modules.printout_template.field.mozarella.title"),
						},
						{
							name: t("modules.printout_template.field.tomato_sauce.title"),
						},
						{
							name: t("modules.printout_template.field.garlic_sauce.title"),
						},
					],
				},
				{
					name: "Pizza Salami",
					quantity: 1,
					seat_name: `${t("modules.printout_template.field.guest.title")} nr 2`,
					item_course: "3",
					price: "36.00 PLN",
					included_additions: [
						{
							name: t("modules.printout_template.field.mozarella.title"),
						},
						{
							name: t("modules.printout_template.field.tomato_sauce.title"),
						},
						{
							name: t("modules.printout_template.field.salami.title"),
						},
					],
					additions: [
						{
							name: t("modules.printout_template.field.garlic_sauce.title"),
							price: "2.00 PLN",
						},
					],
				},
			],
		},
		{
			course: 2,
			items: [
				{
					name: "Fanta 0.3l",
					quantity: 1,
					price: "6.00 PLN",
					item_comment: t("modules.printout_template.field.do_not_pour_into_glass.title"),
					seat_name: `${t("modules.printout_template.field.guest.title")} nr 1`,
					item_course: "1",
				},
				{
					name: "Coca Cola Zero 0.3l",
					quantity: 1,
					price: "6.00 PLN",
					seat_name: `${t("modules.printout_template.field.guest.title")} nr 2`,
					item_course: "2",
				},
				{
					name: `${t("modules.printout_template.field.chips.title")} + Cola`,
					quantity: 1,
					price: "22.00 PLN",
					seat_name: `${t("modules.printout_template.field.guest.title")} nr 3`,
					item_course: "3",
					additions_separated: [
						{
							quantity: 1,
							name: "Cola (250 ml)",
						},
						{
							quantity: 1,
							name: `${t("modules.printout_template.field.chips.title")} (${t(
								"modules.printout_template.field.portion.title"
							)})`,
						},
						{
							quantity: 1,
							name: `${t("modules.printout_template.field.chips.title")}(${t(
								"modules.printout_template.field.portion.title"
							)})`,
						},
					],
					additions: [
						{
							name: t("modules.printout_template.field.sweet_sauce.title"),
							quantity: 1,
						},
					],
				},
			],
		},
	],
	client: {
		name: "Piotr Nowak",
		address_build_nr: "43A",
		address_city: "Kraków",
		address_zip_code: "31-510",
		address_street: "Rakowicka",
		contact_email: "gopos@gopos.pl",
		contact_phone_number: "600 600 600",
	} as ClientApi,
	address: {
		street: "Rakowicka",
		build_nr: "43A",
		zip_code: "31-510",
		city: "Kraków",
	},
	other_directions: [t("modules.printout_template.field.direction.title"), t("common.word.bar")],
	direction_if_different: t("modules.printout_template.field.direction.title"),
});

// t("enums.printout.font.SMALL")
// t("enums.printout.font.DELIVERY")
// t("enums.printout.font.LARGE")
// t("enums.printout.font.LARGE_DOUBLE_WIDTH")
// t("enums.printout.font.DOUBLE_WIDTH")
